import React from 'react'
import {Icon} from 'antd'

export const helperMessage = () => (
  <div className="flex-row align-center justify-center">
    <Icon style={{paddingRight: '1rem'}} type="arrow-up" />
    Drag files here to attach
  </div>
)
